import React from "react";
import Link from "next/link";
import { Button, buttonVariants } from "./button";
import { VariantProps } from "class-variance-authority";
import { cn } from "@/lib/utils";

export interface ButtonProps extends 
  React.ButtonHTMLAttributes<HTMLButtonElement>,
  VariantProps<typeof buttonVariants> {
  title: string;
  href?: string;
  sectionId?: string;
  iconRight?: React.ReactNode;
  iconLeft?: React.ReactNode;
}

export function SmartButton({
  title,
  href,
  sectionId,
  iconRight,
  iconLeft,
  className,
  variant = "default",
  size = "default",
  onClick,
  ...props
}: ButtonProps) {
  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    if (sectionId) {
      e.preventDefault();
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
    onClick?.(e);
  };

  const buttonContent = (
    <>
      {iconLeft}
      {title}
      {iconRight}
    </>
  );

  if (href) {
    return (
      <Link href={href} className={cn(buttonVariants({ variant, size, className }))}>
        {buttonContent}
      </Link>
    );
  }

  return (
    <Button
      variant={variant}
      size={size}
      className={className}
      onClick={handleClick}
      {...props}
    >
      {buttonContent}
    </Button>
  );
}